<template>
  <div>
    <h1>Manage Roles</h1>
    <div class="mt-5">
      <manage-roles-table :table-items="roles" />
    </div>
  </div>
</template>

<script>
import ManageRolesTable from '@/components/manageRoles/ManageRolesTable'
import { mapState, mapActions } from 'vuex'
export default {
  name: 'manage-roles',
  components: {
    ManageRolesTable
  },
  computed: {
    ...mapState('manageRoles', ['roles'])
  },
  created() {
    this.getRoles()
    this.getClientDetails()
  },
  methods: {
    ...mapActions('manageRoles', ['getRoles']),
    ...mapActions('manageClient', ['getClientDetails'])
  }
}
</script>
